import { render, staticRenderFns } from "./ChoferesComponent.vue?vue&type=template&id=7c32f482&"
import script from "./ChoferesComponent.vue?vue&type=script&lang=js&"
export * from "./ChoferesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports